import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import CalendarShareView from './pages/CalendarShareView';
import MockupReviewView from './pages/MockupReviewView';
import { installFx } from './utils/fx';
import './index.css';

// ── Public shared report viewer ──────────────────────────────────
// /r/<id> renders a published report. The HTML lives in Supabase Storage
// (served as text/plain for safety), so we fetch the text and render it
// ourselves. No login, no app shell — anyone with the link can view it.
const shareMatch = window.location.pathname.match(/^\/r\/([A-Za-z0-9_-]+)/);
// /m/<id> renders a published monthly mockup (same mechanism as /r/ reports).
const mockupMatch = window.location.pathname.match(/^\/m\/([A-Za-z0-9_-]+)/);
// /c/<id> renders a published content calendar (shares the published-mockups bucket).
const calMatch = window.location.pathname.match(/^\/c\/([A-Za-z0-9_-]+)/);
if (shareMatch) {
  const base = process.env.REACT_APP_SUPABASE_URL || '';
  document.title = 'Strategists · Report';
  document.body.style.background = '#0A0A0C';
  document.body.innerHTML = '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;color:rgba(239,235,228,0.42);font-family:sans-serif;font-size:14px;">Loading report…</div>';
  fetch(base + '/storage/v1/object/public/published-reports/' + shareMatch[1] + '.html')
    .then(function (r) { if (!r.ok) throw new Error('not found'); return r.text(); })
    .then(function (html) { document.open(); document.write(html); document.close(); })
    .catch(function () {
      document.body.innerHTML = '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0A0A0C;color:#EFEBE4;font-family:sans-serif;font-size:15px;text-align:center;padding:24px;">This report link is no longer available.</div>';
    });
} else if (mockupMatch) {
  // Interactive client review page for a published mockup (live approve / request-change / reorder).
  document.title = 'Strategists · Mockup';
  document.body.style.background = '#0A0A0C';
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<React.StrictMode><MockupReviewView shareId={mockupMatch[1]} /></React.StrictMode>);
} else if (calMatch) {
  // Interactive collaborative calendar workspace for designers (live read/write).
  document.title = 'Strategists · Content Calendar';
  document.body.style.background = '#0A0A0C';
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<React.StrictMode><CalendarShareView calId={calMatch[1]} /></React.StrictMode>);
} else {
  installFx();                       // tap ripples, card tilt/spotlight, the STR easter egg
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<React.StrictMode><App /></React.StrictMode>);

  // Register the PWA service worker so the app is installable to the home screen,
  // AND make every open tab / installed PWA auto-update after a deploy. Without
  // this, a long-lived install keeps running stale JS (e.g. old save logic that
  // overwrites records) until the user manually hard-refreshes. Here we (a) reload
  // once when a newly-deployed service worker takes control, and (b) actively poll
  // for a new version so devices that never navigate still update themselves.
  if ('serviceWorker' in navigator) {
    var refreshing = false;
    var hadController = !!navigator.serviceWorker.controller; // false on first-ever install
    navigator.serviceWorker.addEventListener('controllerchange', function () {
      if (refreshing || !hadController) return;   // skip reload on the very first install
      refreshing = true;
      window.location.reload();
    });
    window.addEventListener('load', function () {
      navigator.serviceWorker.register('/service-worker.js').then(function (reg) {
        var check = function () { if (reg && reg.update) reg.update().catch(function () {}); };
        check();                                  // check right away on load
        setInterval(check, 60 * 1000);            // ...and every minute after
        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'visible') check();  // ...and when the tab is refocused
        });
      }).catch(function () { /* non-fatal */ });
    });
  }
}
